/**
 * Readable names for the twelve templates, keyed by the Airtable "Reference Letter Template"
 * choice the proxy uses (proxy-server/lib/referenceLetterRules.js TEMPLATES). A test pins this
 * list against the proxy's, so a template added there cannot show up here as a raw file name.
 */
const LABELS: Record<string, string> = {
  'Arbeitszeugnis_FTE_DE_Leadership': 'German · Final · Employee, leads people',
  'Arbeitszeugnis_FTE_DE_No Leadership': 'German · Final · Employee',
  'Arbeitszeugnis_Werkstudent_DE': 'German · Final · Working student',
  'Praktikumszeugnis_DE': 'German · Final · Intern',
  'Zwischenzeugnis_FTE_DE_Leadership': 'German · Interim · Employee, leads people',
  'Zwischenzeugnis_FTE_DE_No Leadership': 'German · Interim · Employee',
  'Zwischenzeugnis_FTE_DE_WS_Intern': 'German · Interim · Intern / working student',
  'ReferenceLetter_FTE_English_Leadership': 'English · Final · Employee, leads people',
  'Reference Letter_FTE_English_No Leadership': 'English · Final · Employee',
  'Reference Letter_Intern_WS_English': 'English · Final · Intern / working student',
  'Interim Letter of Reference_FTE_ENG_Leadership': 'English · Interim · Employee, leads people',
  'Interim Letter of Reference_FTE_ENG_no leadership': 'English · Interim · Employee',
};

export const TEMPLATE_KEYS = Object.keys(LABELS);

/** An interim letter (about a running contract), read off the label so the two cannot disagree. */
export const isInterimTemplate = (name: string | null | undefined) => Boolean(name && LABELS[name]?.includes('· Interim ·'));

/** The readable name; an unknown key is shown as it is rather than hidden. */
export const templateLabel = (name: string | null | undefined) => (name ? LABELS[name] ?? name : '–');
